// ─────────────────────────────────────────────────────────────────────────────
// INSTRUMENT: Critical Thinking Assessment
// Science: Watson-Glaser (1980) CT framework · Facione (1990) Delphi Report
//          Ennis (1985) CT skills taxonomy · Open-domain constructs
// Format: 40 passage-based items · 5 dimensions · 30 min timed · CHC Gc
// Sectors: Consulting · Legal · Finance · BFSI · Management
// Standards: none claimed; platform-specific validity evidence not yet published
// ─────────────────────────────────────────────────────────────────────────────
import { CT_ITEMS, CT_DIMS } from "./questionBank.js";
import { scoreCriticalThinking, CT_NORMS, CT_BANDS, CT_SECTOR_NORMS } from "./scoring.js";

export { CT_DIMS, CT_NORMS, CT_BANDS, CT_SECTOR_NORMS };

const CRITICAL_THINKING = {
  id:           "critical_thinking",
  name:         "Critical Thinking",
  shortName:    "CT",
  icon:         "🧩",
  color:        "#1d4ed8",
  bg:           "#eff6ff",
  description:  "40-item critical thinking assessment across 5 dimensions: Inference, Recognition of Assumptions, Deduction, Interpretation and Evaluation of Arguments. Scored against Global & Indian professional norms (n=7K+).",
  desc:         "40 items · 5 dimensions · 30 min · Passage-based",
  publisher:    "AXIS360 Express",
  version:      "1.0",
  itemCount:    40,
  items:        40,
  totalQuestions: 40,
  timeLimit:    30,
  time:         "30 min",
  timeEstimate: "~30 min",
  format:       "critical_thinking",
  scaleType:    "verbal",
  isCognitive:  true,
  isExpress:    true,
  pricingTier:  "volume",
  creditCost:   20,
  pagesOf:      10,
  totalPages:   4,

  dimensions: CT_DIMS,
  scales:     CT_DIMS.map(d => ({ id:d.id, label:d.label, color:d.color, icon:d.icon })),
  questions:  CT_ITEMS,

  predicts: [
    "Analytical problem-solving in consulting",
    "Legal reasoning and argument quality",
    "Financial decision-making rigour",
    "Senior management judgement",
    "MBA and management trainee potential",
  ],

  nineboxAxes: {
    x: { label:"Analytical Rigour",    scaleIds:["INF","DED","INT"] },
    y: { label:"Critical Judgement",   scaleIds:["ASM","EVL"] },
  },

  score(answers) {
    return scoreCriticalThinking(answers);
  },
};

export default CRITICAL_THINKING;
